<template>
  <div
    class="top-sub-b flex flex-col flex-shrink-0 justify-center align-middle content-center"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "TopSubB"
};
</script>

<style lang="scss" scoped>
.top-sub-b {
  height: 4.928rem;
  flex: 0 0 4.928rem;
}

.top-sub-b /deep/ .tutorial-button {
  top: 50%;
  right: 2.53125rem;
  transform: translate(50%, -50%);
}

@media (min-width: 768px) {
  .top-sub-b {
    height: 5.632rem;
    flex: 0 0 5.632rem;
  }

  .top-sub-b /deep/ .tutorial-button {
    right: 3.7rem;
    transform: translateY(-50%);
  }
}

@media (min-width: 1024px) {
  .top-sub-b {
    height: fit-content;
    flex: 0 0 0;
    margin: 1rem 0 0.5rem 0;
  }
}
</style>
